import '../sass/style.scss'
import './modules/top'

window.addEventListener('load', function () {
  // Nav
  var body = document.querySelector('body')
  var trigger = document.getElementById('navTrigger')
  var nav = document.getElementById('nav')
  trigger.addEventListener('click', function () {
    body.classList.toggle('scroll_stop')
    nav.classList.toggle('is-open')
    trigger.classList.toggle('is-current')
  })

  document.querySelectorAll('.first_nav li').forEach(function (item) {
    item.addEventListener('click', function () {
      body.classList.toggle('scroll_stop')
      nav.classList.toggle('is-open')
      trigger.classList.toggle('is-current')
    })
  })

  document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault()

      const elmHash = this.getAttribute('href')
      const targetElement = document.querySelector(elmHash)

      if (targetElement) {
        const pos = targetElement.offsetTop - 30

        window.scrollTo({
          top: pos,
          behavior: 'smooth', // スムーズなスクロールを実現
        })
      }
    })
  })
  const boxes = document.querySelectorAll('.in-view')

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
        }
      })
    },
    {
      root: null,
      threshold: 0.2,
    },
  )
  boxes.forEach((box) => observer.observe(box))
})
